export const LOCAL = 'local';
export const DEVELOPMENT = 'Development';
export const STAGING = 'Staging';
export const PRODUCTION = 'Production';
